/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Imagesdeleteimage2Inputs */

const en_imagesdeleteimage2 = /** @type {(inputs: Imagesdeleteimage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove picture`)
};

const de_imagesdeleteimage2 = /** @type {(inputs: Imagesdeleteimage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild entfernen`)
};

/**
* | output |
* | --- |
* | "Remove picture" |
*
* @param {Imagesdeleteimage2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const imagesdeleteimage2 = /** @type {((inputs?: Imagesdeleteimage2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Imagesdeleteimage2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_imagesdeleteimage2(inputs)
	return de_imagesdeleteimage2(inputs)
});
export { imagesdeleteimage2 as "imagesDeleteImage" }